import React from 'react'
import SignUp from '../components/Accounts/Signup';
import Navbar from '../components/Navbar'
const SignupPage = () => {
  return (
    <div>
      <Navbar/>
      <SignUp/>
    </div>
  );
};

export default SignupPage;